import {
  AnalyticsConfiguration,
  interactionEvent,
  notificationEvent,
  pageViewEvent,
  selfServeCompleteEvent,
  selfServeStartWithInteractionEvents,
} from '@rci/self-serve-fido/core/analytics';
import { formErrorPayload, modalPageView, selfServe } from './common-analytics.config';

const pageName = 'modal - update your credit card';

const getMappings = (hierarchy: string): AnalyticsConfiguration => {
  return {
    mappings: {
      alertCtaTracking: {
        events: interactionEvent,
        page: { name: hierarchy, hierarchy: ['myaccount', `${hierarchy}`] },
      },
      buttonInteraction: {
        events: interactionEvent,
        page: modalPageView(pageName, hierarchy),
      },
      formError: {
        page: modalPageView(pageName, hierarchy),
      },
      updateCCAlert: {
        events: notificationEvent,
        page: { name: hierarchy, hierarchy: ['myaccount', `${hierarchy}`] },
      },
      updateCCError: {
        page: modalPageView(pageName, hierarchy),
      },
      updateCCPageView: {
        events: pageViewEvent,
        page: modalPageView(pageName, hierarchy),
      },
      updateCCSelfServeStart: {
        events: selfServeStartWithInteractionEvents,
        page: modalPageView(pageName, hierarchy),
        selfServe: selfServe('update credit card'),
      },
      updateCCSuccess: {
        events: selfServeCompleteEvent,
        page: modalPageView(pageName, hierarchy),
        selfServe: selfServe('update credit card'),
      },
    },
  };
};

export const updateCCModalAnalyticsConfig = {
  updateCCAlertAnalyticsConfig: {
    alertCtaTracking: {
      mappingKey: 'alertCtaTracking',
      additionalPayload: {
        interaction: {
          name: 'update your credit card',
          type: 'click',
        },
      },
    },
    dismissAlertTracking: {
      mappingKey: 'alertCtaTracking',
      additionalPayload: {
        interaction: {
          name: 'credit card expire - close',
          type: 'click',
        },
      },
    },
    displayAlertTracking: {
      mappingKey: 'updateCCAlert',
      additionalPayload: {
        notification: [
          {
            id: '',
            type: 'banner',
            name: '',
            message: '',
            position: 'top',
          },
        ],
      },
    },
  },
  buttonInteraction: {
    mappingKey: 'buttonInteraction',
    additionalPayload: {
      interaction: {
        name: '',
        type: 'click',
      },
    },
  },
  creditCardDetailsError: {
    creditCard: formErrorPayload('credit card'),
    expiryDate: formErrorPayload('expiry date'),
    cvvCode: formErrorPayload('security code'),
  },
  updateCCError: {
    mappingKey: 'updateCCError',
  },
  updateCCPageView: {
    mappingKey: 'updateCCPageView',
  },
  updateCCSelfServeStart: {
    mappingKey: 'updateCCSelfServeStart',
    additionalPayload: {
      interaction: {
        name: '',
        type: 'click',
      },
    },
  },
  updateCCSuccess: {
    mappingKey: 'updateCCSuccess',
  },
};

export const updateCCModalAnalyticsConfiguration = (hierarchy: string): AnalyticsConfiguration => {
  return getMappings(hierarchy);
};
